export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/trap.6f60ddc.svg";